import { render, staticRenderFns } from "./DetalleProgramar.vue?vue&type=template&id=f788c4ec&"
import script from "./DetalleProgramar.vue?vue&type=script&lang=js&"
export * from "./DetalleProgramar.vue?vue&type=script&lang=js&"
import style0 from "./DetalleProgramar.vue?vue&type=style&index=0&id=f788c4ec&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports